import { WalletController } from '../../controllers';
import { TransferSuccess } from '../../pages';
import constant from '../../utils/constant';
import { useStores, userStore } from '../../stores';
import React, { useState } from 'react';
import * as yup from 'yup';

const TransferSuccessContainer = ({ closeModal, setShowSurvey, needFeedback }) => {
	const { walletStore } = useStores();
	const onCloseModal = () => {
		closeModal();
		if (needFeedback._id) {
			setShowSurvey(true)
			userStore.setReviewId(needFeedback._id)
		}
		return;
	}
	return (
		<TransferSuccess
			payload={walletStore.transferPayload}
			closeModal={onCloseModal}
		/>
	);
};

export default TransferSuccessContainer;
